<ng-container [formGroup]="GenForm">
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <!-- ================== General Fields (Start) ================== -->
    <div class="w50 summary-anamnesis" style="height: 50%">
      <section class="m-box">
        <h2>Referral Request</h2>

        <textarea class="style" formControlName="referralRequest"> </textarea>
        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed"
          (click)="atS.showAuto(GenForm.get('referralRequest'), ' Referral Request', 35)"
        >
          Auto Text
        </button>
      </section>
    </div>

    <div class="w50 summary-recommendations" style="height: 50%">
      <section class="m-box">
        <h2>Measured by Software</h2>

        <textarea class="style" formControlName="software"> </textarea>

        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed"
          (click)="atS.showAuto(GenForm.get('software'), ' Measured by Software', 36)"
        >
          Auto Text
        </button>
      </section>
    </div>

    <div class="w50 summary-anamnesis" style="height: 50%">
      <section class="m-box">
        <h2>Medical History</h2>

        <button
          class="t-btn-smart"
          *ngIf="!es.isClosed && ls.premissions && ls.premissions.Questionnaires"
          [disabled]="aiSummaryLoading"
          style="margin-bottom: 0.5em"
          (click)="getAiSummary()"
        >
          {{ 'GUI.General.Buttons.Populate Smart History' | translate }}
          <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
        </button>
        <textarea class="scroller" formControlName="MedicalHistory"> </textarea>
        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed"
          (click)="atS.showAuto(GenForm.get('MedicalHistory'), 'Medical History', 1)"
        >
          Auto Text
        </button>
      </section>
    </div>

    <div class="w50 summary-recommendations" style="height: 50%">
      <section class="m-box">
        <h2>Technician's Comments</h2>

        <textarea class="scroller" formControlName="TechComment"> </textarea>

        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed"
          (click)="atS.showAuto(GenForm.get('TechComment'), 'Reason for Examinanion', 110)"
        >
          Auto Text
        </button>
      </section>
    </div>
    <!-- ================== General Fields (End) ================== -->

    <!-- ================== Findings (Start) ================== -->
    <div class="w100 summary-anamnesis">
      <section class="m-box" style="height: auto">
        <h2>Findings</h2>
        <div
          *ngIf="
            es.ExamType === 'FOV' ||
            es.ExamType == 'Pachymetry' ||
            es.ExamType === 'TOPEye' ||
            es.ExamType === 'Fundus'
          "
          class="l-flex-c l-flex-w l-justify h50 placenta-row"
          style="margin: 0 0 1em"
        >
          <div class="w49 summary-anamnesis" style="width: 49%">
            <section class="m-box">
              <h2>Left Eye</h2>
              <textarea class="scroller" formControlName="LeftEyeFov"></textarea>
              <button
                class="t-btn-edit"
                *ngIf="!es.isClosed"
                (click)="atS.showAuto(GenForm.get('LeftEyeFov'), 'Left Eye ', 111)"
              >
                Auto Text
              </button>
            </section>
          </div>

          <div class="w49 summary-anamnesis" style="width: 49%">
            <section class="m-box">
              <h2>Right Eye</h2>
              <textarea class="scroller" formControlName="RightEyeFov"></textarea>

              <button
                class="t-btn-edit"
                *ngIf="!es.isClosed"
                (click)="atS.showAuto(GenForm.get('RightEyeFov'), 'Right Eye ', 112)"
              >
                Auto Text
              </button>
            </section>
          </div>
        </div>

        <!-- ================== Macular (Start) ================== -->
        <ng-container *ngIf="es.ExamType === 'OCT' || es.ExamType === 'OCTMacular'">
          <div class="w100 summary-anamnesis">
            <section class="m-box" style="height: auto">
              <h2 style="margin-left: 10%">Macular</h2>
              <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin: 0 0 1em">
                <div class="w49 summary-anamnesis" style="width: 49%">
                  <section class="m-box">
                    <h2>Left Eye</h2>
                    <textarea class="scroller" formControlName="LeftEyeMacular"></textarea>

                    <button
                      class="t-btn-edit"
                      *ngIf="!es.isClosed"
                      (click)="atS.showAuto(GenForm.get('LeftEyeMacular'), ' Macular Left Eye  ', 113)"
                    >
                      Auto Text
                    </button>
                  </section>
                </div>

                <div class="w49 summary-anamnesis" style="width: 49%">
                  <section class="m-box">
                    <h2>Right Eye</h2>
                    <textarea class="scroller" formControlName="RightEyeMacular"></textarea>

                    <button
                      class="t-btn-edit"
                      *ngIf="!es.isClosed"
                      (click)="atS.showAuto(GenForm.get('RightEyeMacular'), 'Macular Right Eye ', 114)"
                    >
                      Auto Text
                    </button>
                  </section>
                </div>
              </div>
            </section>
          </div>
        </ng-container>
        <!-- ================== Macular (End) ================== -->

        <!-- ================== Ophthalmic Nerve (Start) ================== -->
        <ng-container *ngIf="es.ExamType === 'OCT' || es.ExamType === 'OCTOptic'">
          <div class="w100 summary-anamnesis" style="margin-top: 10px">
            <section class="m-box" style="height: auto">
              <h2 style="margin-left: 10%">Ophthalmic Nerve</h2>
              <div class="l-flex-c l-flex-w l-justify h50 placenta-row" style="margin: 0 0 1em">
                <div class="w49 summary-anamnesis" style="width: 49%">
                  <section class="m-box">
                    <h2>Left Eye</h2>
                    <textarea class="scroller" formControlName="LeftEyeNerve"></textarea>

                    <button
                      class="t-btn-edit"
                      *ngIf="!es.isClosed"
                      (click)="atS.showAuto(GenForm.get('LeftEyeNerve'), 'Left Eye ', 113)"
                    >
                      Auto Text
                    </button>
                  </section>
                </div>

                <div class="w49 summary-anamnesis" style="width: 49%">
                  <section class="m-box">
                    <h2>Right Eye</h2>
                    <textarea class="scroller" formControlName="RightEyeNerve"></textarea>

                    <button
                      class="t-btn-edit"
                      *ngIf="!es.isClosed"
                      (click)="atS.showAuto(GenForm.get('RightEyeNerve'), 'Right Eye ', 114)"
                    >
                      Auto Text
                    </button>
                  </section>
                </div>
              </div>
            </section>
          </div>
        </ng-container>
        <!-- ================== Ophthalmic Nerve (End) ================== -->
      </section>
    </div>
    <!-- ================== Findings (End) ================== -->

    <!-- ================== Summary (Start) ================== -->
    <div class="w100">
      <section class="m-box">
        <h2>Summary of Exam</h2>
        <angular-editor
          formControlName="SummaryHtml"
          [config]="editorConfig"
          style="width: 100%"
        ></angular-editor>
        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed"
          (click)="atS.showAuto(GenForm.get('SummaryHtml'), 'Diagnosis', 115)"
        >
          Auto Text
        </button>
      </section>
    </div>
    <!-- ================== Summary (End) ================== -->

    <!-- ================== Summary (Start) ================== -->
    <div style="width: 100%; display: inline-flex">
      <div
        class="summary-boxHeight summary-referringDr"
        [ngClass]="ls.userType === 'secretary' ? 'w170' : 'w50'"
        style="padding: 0 1em 0 0"
      >
        <section
          class="m-box"
          [ngStyle]="ls.userType === 'secretary' ? { height: '120%' } : {}"
          [formGroup]="awlForm"
        >
          <h2>HMO</h2>
          <div class="l-flex-c l-flex-w indicative-fieldset">
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Leumit" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span> Leumit </span>
            </label>

            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Clalit" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span> Clalit </span>
            </label>

            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Macabi" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span> Macabi </span>
            </label>

            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Meuhedet" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span> Meuhedet </span>
            </label>
            <label class="t-label">
              <input type="radio" formControlName="HMO" value="Private" class="custom-check -sq" />
              <i class="customInput-display -sq"></i>
              <span> Private </span>
            </label>
          </div>
          <div style="display: flex; flex-direction: row" *ngIf="awlForm.get('AutoIndex').value">
            <div
              style="display: flex; flex-direction: row; flex-wrap: wrap; margin-top: 1em; width: 120%"
              *ngIf="ls.userType == 'secretary' && es.AWLID"
            >
              <div
                class="w50"
                *ngIf="
                  awlForm.get('HMO').value == 'Macabi' ||
                  awlForm.get('HMO').value == 'Leumit' ||
                  awlForm.get('HMO').value == 'Meuhedet' ||
                  awlForm.get('HMO').value == 'Clalit'
                "
              >
                <div class="l-flex l-flex-c t-field t-field-pad input">
                  <label
                    matTooltip="מס. התחייבות"
                    *ngIf="
                      awlForm.get('HMO').value == 'Macabi' ||
                      awlForm.get('HMO').value == 'Leumit' ||
                      awlForm.get('HMO').value == 'Meuhedet'
                    "
                  >
                    מספר התחייבות
                  </label>
                  <label matTooltip="מס. הפניה" *ngIf="awlForm.get('HMO').value == 'Clalit'">
                    קוד הזמנה/הפניה
                  </label>

                  <i class="t-sep"></i>

                  <span class="t-validation-wrap l-fg1">
                    <input
                      type="number"
                      [formControlName]="
                        awlForm.get('ExamCode').value === 'FOV + OCT' &&
                        es.ExamType === 'OCT' &&
                        awlForm.get('HMO').value == 'Clalit'
                          ? 'PRN2'
                          : 'PRN'
                      "
                      class="t-field-text w100"
                    />
                  </span>
                </div>
              </div>

              <div
                class="w50"
                *ngIf="awlForm.get('HMO').value == 'Macabi' || awlForm.get('HMO').value == 'Clalit'"
              >
                <div
                  class="l-flex l-flex-c t-field t-field-pad input"
                  matTooltip=" רשיון רופא/זיהוי מזמין"
                >
                  <label *ngIf="awlForm.get('HMO').value == 'Clalit'"> רשיון רופא/זיהוי מזמין </label>
                  <label *ngIf="awlForm.get('HMO').value == 'Macabi'"> מס. רופא מפנה </label>

                  <i class="t-sep"></i>
                  <span class="t-validation-wrap l-fg1">
                    <input
                      type="number"
                      [formControlName]="
                        awlForm.get('ExamCode').value === 'FOV + OCT' &&
                        es.ExamType === 'OCT' &&
                        awlForm.get('HMO').value == 'Clalit'
                          ? 'Code2'
                          : 'Code'
                      "
                      class="t-field-text w100"
                    />
                  </span>
                </div>
              </div>
              <div
                class="w50"
                *ngIf="awlForm.get('HMO').value == 'Macabi' || awlForm.get('HMO').value == 'Clalit'"
              >
                <div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="שם פרטי המזמין">
                  <label *ngIf="awlForm.get('HMO').value == 'Macabi'"> שם רופא מפנה </label>
                  <label *ngIf="awlForm.get('HMO').value == 'Clalit'"> שם פרטי רופא מזמין </label>

                  <i class="t-sep"></i>
                  <span class="t-validation-wrap l-fg1">
                    <input
                      type="text"
                      [formControlName]="
                        awlForm.get('ExamCode').value === 'FOV + OCT' &&
                        es.ExamType === 'OCT' &&
                        awlForm.get('HMO').value == 'Clalit'
                          ? 'refDocName2'
                          : 'refDocName'
                      "
                      class="t-field-text w100"
                    />
                    <div class="t-validation-message">
                      <span>Invalid Doctor ID</span>
                    </div>
                  </span>
                </div>
              </div>
              <div class="w50" *ngIf="awlForm.get('HMO').value == 'Clalit'">
                <div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="שם משפחה המזמין">
                  <label> שם משפחה רופא מזמין </label>

                  <i class="t-sep"></i>
                  <span class="t-validation-wrap l-fg1">
                    <input
                      type="text"
                      [formControlName]="
                        awlForm.get('ExamCode').value === 'FOV + OCT' &&
                        es.ExamType === 'OCT' &&
                        awlForm.get('HMO').value == 'Clalit'
                          ? 'refDocLastName2'
                          : 'refDocLastName'
                      "
                      class="t-field-text w100"
                    />
                    <div class="t-validation-message">
                      <span>Invalid Doctor ID</span>
                    </div>
                  </span>
                </div>
              </div>
              <div class="w50" *ngIf="awlForm.get('HMO').value == 'Clalit'">
                <div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="גורם שולח">
                  <label>גורם שולח</label>

                  <i class="t-sep"></i>
                  <span class="t-validation-wrap l-fg1">
                    <input
                      type="number"
                      [formControlName]="
                        awlForm.get('ExamCode').value === 'FOV + OCT' &&
                        es.ExamType === 'OCT' &&
                        awlForm.get('HMO').value == 'Clalit'
                          ? 'BranchProviderID2'
                          : 'BranchProviderID'
                      "
                      class="t-field-text w100"
                    />
                  </span>
                </div>
              </div>
              <div class="w50" *ngIf="awlForm.get('HMO').value == 'Clalit'">
                <div class="l-flex l-flex-c t-field t-field-pad input" matTooltip="מרפאה">
                  <label>מרפאה</label>

                  <i class="t-sep"></i>
                  <span class="t-validation-wrap l-fg1">
                    <input
                      type="text"
                      [formControlName]="
                        awlForm.get('ExamCode').value === 'FOV + OCT' &&
                        es.ExamType === 'OCT' &&
                        awlForm.get('HMO').value == 'Clalit'
                          ? 'BranchProviderName2'
                          : 'BranchProviderName'
                      "
                      class="t-field-text w100"
                    />
                    <div class="t-validation-message">
                      <span>Invalid Doctor ID</span>
                    </div>
                  </span>
                </div>
              </div>
            </div>
            <div
              *ngIf="
                awlForm.get('HMO').value == 'Clalit' &&
                ls.userType === 'secretary' &&
                es.ExamType != 'Pachymetry'
              "
            >
              <label class="observe" style="margin: 2em">
                <input
                  type="radio"
                  class="custom-check customInput"
                  [(ngModel)]="xmlMode"
                  name="xmlModeGroup"
                  [ngModelOptions]="{ standalone: true }"
                  value="1"
                /><i class="customInput-display"></i>

                <span> New </span>
              </label>

              <label class="not-observed">
                <input
                  type="radio"
                  class="custom-check customInput"
                  [(ngModel)]="xmlMode"
                  name="xmlModeGroup"
                  [ngModelOptions]="{ standalone: true }"
                  value="2"
                /><i class="customInput-display"></i>

                <span> Update </span>
              </label>
              <label class="not-observed">
                <input
                  type="radio"
                  class="custom-check customInput"
                  [(ngModel)]="xmlMode"
                  name="xmlModeGroup"
                  [ngModelOptions]="{ standalone: true }"
                  value="3"
                /><i class="customInput-display"></i>

                <span> Cancel </span>
              </label>
              <button
                class="search-btn search-btn--newPatient"
                style="margin: 1em 4em; width: 50%"
                (click)="downloadXml()"
                [disabled]="!xmlMode || xmlLoading"
                matTooltip="Build and Download xml"
              >
                Build and Download
              </button>
            </div>
          </div>
        </section>
      </div>
      <div class="w50 summary-referringDr" style="padding: 0 0 0 1em">
        <section class="m-box padd" style="height: 30%" (dblclick)="GenForm.get('ReffDoc').setValue(-1)">
          <h2>Referring Doctor</h2>
          <textarea class="fulltext minH4" formControlName="ReffDoc"></textarea>
        </section>
        <section
          class="m-box padd"
          style="height: 50%"
          (dblclick)="GenForm.get('ProcedureResult').setValue(null)"
        >
          <h2>Procedure Results</h2>
          <div class="l-flex-c l-flex-w indicative-fieldset h100">
            <label class="t-label-top">
              <input
                type="radio"
                formControlName="ProcedureResult"
                value="No Clinical Findings"
                class="custom-check -sq"
              />
              <i class="customInput-display -sq"></i>
              <span> No Clinical Findings </span>
            </label>

            <label class="t-label-top">
              <input
                type="radio"
                formControlName="ProcedureResult"
                value="Clinical Findings"
                class="custom-check -sq"
              />
              <i class="customInput-display -sq"></i>
              <span> Clinical Findings </span>
            </label>

            <label class="t-label-top">
              <input
                type="radio"
                formControlName="ProcedureResult"
                value="Urgent Clinical Findings"
                class="custom-check -sq"
              />
              <i class="customInput-display -sq"></i>
              <span> Urgent Clinical Findings </span>
            </label>
          </div>
        </section>
      </div>
    </div>
    <div class="w100">
      <section class="m-box">
        <h2>
          {{ "summary.Terms" | translate | titlecase }}
        </h2>
        <textarea class="scroller" formControlName="Terms" [readonly]="ls.isSite"></textarea>
        <button
          class="t-btn-edit"
          *ngIf="!es.isClosed && !ls.isSite"
          (click)="atS.showAuto(GenForm.get('Terms'), 'Terms', 800)"
        >
          Auto Text
        </button>
      </section>
    </div>
  </div>
</ng-container>
